import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useQueryClient } from '@tanstack/react-query';
import { useOrganization } from '@/contexts/OrganizationContext';

export function useInfluencerEnrichmentRealtime() {
  const queryClient = useQueryClient();
  const { currentOrganization } = useOrganization();
  const orgId = currentOrganization?.id;

  useEffect(() => {
    if (!orgId) return;

    // Listen for changes on the influencers table filtered by organization_id
    const channel = supabase
      .channel(`schema-db-changes:${orgId}`)
      .on(
        'postgres_changes',
        {
          event: 'UPDATE',
          schema: 'public',
          table: 'influencers',
          filter: `organization_id=eq.${orgId}`,
        },
        (payload) => {
          // If the enrichment_status or related fields changed, invalidate queries to trigger a re-render
          const newRow = payload.new as any;
          const oldRow = payload.old as any;
          
          if (newRow.enrichment_status !== oldRow.enrichment_status || 
              newRow.followers_count !== oldRow.followers_count || 
              newRow.profile_pic_url !== oldRow.profile_pic_url) {
            
            // Invalidate the relevant queries (e.g., 'influencers' list)
            queryClient.invalidateQueries({ queryKey: ['influencers'] });
            // Invalidate specific influencer if looking at detail view
            if (newRow.id) {
              queryClient.invalidateQueries({ queryKey: ['influencer', newRow.id] });
            }
          }
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [queryClient, orgId]);
}
